import React from 'react';
import cx from 'classnames';
import { NavLink } from 'react-router-dom';

import { getUniqueKey } from 'app/utils/helpers';

import s from './Breadcrumbs.module.sass';

type BreadcrumbsProps = {
  data: {
    current: string
    prev: string
  },
  className?: string
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  data,
  className,
}) => {
  const { current, prev } = data;

  const splitArray = prev.split('/');
  const removeLastItem = splitArray.splice(0, splitArray.length - 1);

  return (
    <div className={cx(s.root, className)}>
      {
        removeLastItem.map((item: any) => {
          if (item) {
            return (
              <React.Fragment key={getUniqueKey()}>
                <NavLink
                  to={`/${item}`}
                  className={cx(s.link)}
                >
                  {item}
                </NavLink>
                {'>'}
              </React.Fragment>
            );
          }

          return undefined;
        })
      }
      <span className={cx(s.currentRoute)}>{current}</span>
    </div>
  );
};

export default Breadcrumbs;
